/**
 * Created by mac on 2018/11/19.
 * @desc 腾讯sdk，分享相关
 */
const init = (sigOption, share) => {
    // eslint-disable-next-line
    const wxObj = wx;
    wxObj.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: sigOption.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: sigOption.timestamp, // 必填，生成签名的时间戳
        nonceStr: sigOption.noncestr, // 必填，生成签名的随机串
        signature: sigOption.signature, // 必填，签名
        jsApiList: [
            'checkJsApi',
            'openLocation',
            'getLocation',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareAppMessage',
            'onMenuShareTimeline'
        ] // 必填，需要使用的JS接口列表，所有JS接口列
    });
    wxObj.ready(() => {
        // //需在用户可能点击分享按钮前就先调用
        // wxObj.updateAppMessageShareData({
        //     title: 'we222r', // 分享标题
        //     desc: '123123', // 分享描述
        //     link: 'https://apollo-dev.nio.com' + window.location.search, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: '', // 分享图标
        //     success: function() {
        //         console.log('updateAppMessageShareData： success');
        //     }
        // });
        // 分享好友
        wxObj.onMenuShareAppMessage({
            title: share.product_title, // 分享标题
            desc: share.product_description, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share.product_image_url, // 分享图标
            success: function() {
                // console.log('onMenuShareAppMessage： success');
            }
        });
        // 分享朋友圈
        wxObj.onMenuShareTimeline({
            title: share.product_title, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share.product_image_url, // 分享图标
            success: function() {
                // 用户点击了分享后执行的回调函数
            }
        });
    });
    wxObj.error(res => {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log('wx error:  ', res);
    });
};

export default init;



// WEBPACK FOOTER //
// ./src/util/third-party/wx-js-sdk.js